import React from 'react'
import { connect } from 'react-redux'
import { change as changeFieldValue } from 'redux-form';
import selecionarAgencia from '../../actions/agencia/selecionarAgencia';
import alterarExibicaoDetalhamentoAgencia from '../../actions/agencia/alterarExibicaoDetalhamentoAgencia';
import DetalheAgencia from './DetalheAgencia';


export class Agencia extends React.Component {
  selecionarAgencia (agencia) {
    this.props.changeFieldValue('formularioCadastrarCidade',
      'logradouro', agencia.logradouro);
    this.props.changeFieldValue('formularioCadastrarCidade',
      'complemento', agencia.complemento);
    this.props.changeFieldValue('formularioCadastrarCidade',
      'bairro', agencia.bairro);
    this.props.changeFieldValue('formularioCadastrarCidade',
      'localidade', agencia.localidade);
    this.props.changeFieldValue('formularioCadastrarCidade',
      'uf', agencia.uf);
    this.props.changeFieldValue('formularioCadastrarCidade',
      'cep', agencia.cep);
    this.props.changeFieldValue('formularioCadastrarCidade',
      'idAgencia', agencia.id);
    this.props.changeFieldValue('formularioCadastrarCidade',
      'nome', agencia.nome);
    this.props.changeFieldValue('formularioCadastrarCidade',
      'numero', agencia.numero);
  }


  iconeBloqueioDesbloqueio () {
    if (this.props.agencia.bloqueada) {
      return <i className="material-icons nav-icon">&#xe899;</i>
    }
    return <i className="material-icons nav-icon">&#xe898;</i>
  }

  exibirIcone () {
    if (this.props.agencia.exibirConteudo) {
      return <i className="material-icons" style={{ cursor: 'pointer' }} onClick={() => this.props.alterarExibicaoDetalhamentoAgencia(this.props.agencia)}>
        &#xE5C7;</i>
    }
    return <i className="material-icons" style={{ cursor: 'pointer' }} onClick={() => this.props.alterarExibicaoDetalhamentoAgencia(this.props.agencia)}>&#xE5C5;</i>
  }


  render () {
    return (
      <div className="geral">
        <div className="resumo">
          <div className="row">
            <div className="col" style={{ cursor: 'pointer' }}>
              {this.exibirIcone()}
            </div>
            <div className="col">
              <span className="titulo-mobile">Número:&nbsp;</span>{this.props.agencia.id}
            </div>
            <div className="col">
              <span className="titulo-mobile">Nome:&nbsp;</span>{this.props.agencia.nome}
            </div>

            <div className="col">
              <span className="titulo-mobile">Localidade:&nbsp;</span>{this.props.agencia.localidade}
            </div>

            <div className="col">
              <span className="titulo-mobile">UF:&nbsp;</span>{this.props.agencia.uf}
            </div>

            <div className="col">
              <span className="titulo-mobile">Logradouro:&nbsp;</span>{this.props.agencia.logradouro}
            </div>

            <div className="col">
              <span className="titulo-mobile">Bairro:&nbsp;</span>{this.props.agencia.bairro}
            </div>

            <div className="col">
              <span className="titulo-mobile">Cep:&nbsp;</span>{this.props.agencia.cep}
            </div>

            <div className="col-12 col-sm-2 col-md-2 col-lg-2 col-xl-2">
              <div className="acoes">
                <div className="botoes">
                  <button type="button" className="btn btn-excluir"
                          data-toggle="modal"
                          data-target="#modalConfirmacaoExclusaoAgencia"
                          onClick={() => this.props.selecionarAgencia(this.props.agencia)}>
                    <i className="material-icons nav-icon">&#xe872;</i>
                  </button>
                  <button type="button" className="btn btn-editar ml-2"
                          data-toggle="modal"
                          data-target="#modalCadastrarAgencia"
                          onClick={() => {
                            this.props.selecionarAgencia(this.props.agencia)
                            this.selecionarAgencia(this.props.agencia)
                          }}>
                    <i className="material-icons nav-icon">&#xe150;</i>
                  </button>
                  <button type="button" className="btn btn-excluir"
                          data-toggle="modal"
                          title={`${this.props.agencia.bloqueada ? 'Desbloquear agência' : 'Bloquear agência'}`}
                          data-target="#modalConfirmacaoBloqueioAgencia"
                          onClick={() => {
                            this.props.selecionarAgencia(this.props.agencia)
                          }}>
                    {this.iconeBloqueioDesbloqueio()}
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
        <DetalheAgencia agencia={this.props.agencia}/>
      </div>
    )
  }
}

export function mapStateToProps () {
  return {}
}

export default connect(mapStateToProps, {
  selecionarAgencia,
  alterarExibicaoDetalhamentoAgencia,
  changeFieldValue
})(Agencia)
